var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-sub-section notes-section",staticStyle:{"height":"100%"}},[_c('BulkCreate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }